import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';

export const unfilteredOptionsId = `${ScreenPicker.uom}_all`;
